import { atom } from 'recoil'
import { PreviewPDFModalProps } from './types'


const initPreviewPDFModal: PreviewPDFModalProps = false

const previewPDFModalAtom = atom<PreviewPDFModalProps>({
  key: 'previewPDFModalAtom',
  default: initPreviewPDFModal,
})

export default previewPDFModalAtom
